/**
 * Capas dos artigos servidas do próprio site, em WebP e três larguras.
 *
 * Até 26/09/2026, 24 posts usavam fotos do Unsplash hotlinkadas em JPEG de
 * 1200 px (100–415 KB cada, sem `srcset`, de um domínio externo sem
 * `preconnect`) e 9 usavam JPEGs locais de 100–250 KB. A capa é a imagem de
 * LCP da página do artigo. Aqui cada uma foi recortada em 16:9 e convertida
 * para WebP em 1200/800/480 px (`public/blog/capas/`), e a média caiu para
 * ~40 KB na maior largura.
 *
 * A resolução é por SLUG, no render, em vez de trocar `cover_image_url` no
 * banco: o banco continua com a URL original (guardada também em
 * docs/auditoria-seo-2026-09-26/capas-originais.json), então voltar atrás é
 * só remover o slug daqui. Post novo cuja capa não esteja nesta lista continua
 * usando a URL do CMS.
 */
const SLUGS_COM_CAPA_LOCAL = new Set([
  'bioimpedancia-vs-balanca-comum-diferencas',
  'burnout-fisico-metabolico-tratamento',
  'como-preparar-corpo-usar-glp1-protocolo',
  'cortisol-alto-estresse-metabolismo-gordura-abdominal',
  'deficiencia-nutricional-pos-bariatrica-sinais',
  'dor-articular-sem-diagnostico-tratamento-integrativo',
  'dorme-8-horas-acorda-exausta-causa',
  'efeito-sanfona-causa-metabolica-como-resolver',
  'fadiga-cronica-mulheres-causas-tratamento',
  'fibromialgia-diagnostico-tratamento-integrativo',
  'glp1-perda-muscular-como-preservar',
  'hashimoto-lupus-medicina-integrativa-complemento',
  'inflamacao-cronica-silenciosa-sinais',
  'linearz-flacidez-pos-glp1',
  'mapeamento-corporal-clinica-habitus',
  'medicina-integrativa-brasilia-como-escolher',
  'medicina-integrativa-vs-convencional-diferencas',
  'menopausa-ganho-de-peso-causa-tratamento',
  'mounjaro-tirzepatida-riscos-sem-acompanhamento',
  'ozonioterapia-o-que-e-como-funciona',
  'por-que-peso-volta-depois-ozempic',
  'quando-procurar-medico-integrativo-sinais',
  'quantas-sessoes-ozonioterapia-resultado',
  'quanto-custa-bioimpedancia-inbody-brasilia',
  'queda-cabelo-ozempic-mounjaro-tratamento',
  'radiofrequencia-density-perguntas-frequentes',
  'reposicao-hormonal-feminina-guia-completo',
  'resistencia-insulina-o-que-e-como-reverter',
  'saude-intestinal-emagrecimento-microbioma',
  'soroterapia-o-que-e-para-que-serve',
  'tireoide-cansaco-peso-hipotireoidismo',
  'vitamina-d-b12-magnesio-deficiencias-energia',
]);

const SITE_URL = 'https://www.clinicahabitus.com.br';

export interface CapaDoPost {
  /** URL principal (1200 px quando local). */
  src: string;
  /** `srcset` com as três larguras; vazio quando a capa vem do CMS. */
  srcSet?: string;
  /** URL absoluta, para og:image e JSON-LD. */
  absoluta: string;
  width: number;
  height: number;
}

export function capaDoPost(
  slug: string | undefined,
  coverImageUrl: string | null | undefined,
): CapaDoPost | null {
  if (slug && SLUGS_COM_CAPA_LOCAL.has(slug)) {
    const base = `/blog/capas/${slug}`;
    return {
      src: `${base}.webp`,
      srcSet: `${base}-480.webp 480w, ${base}-800.webp 800w, ${base}.webp 1200w`,
      absoluta: `${SITE_URL}${base}.webp`,
      width: 1200,
      height: 675,
    };
  }
  if (!coverImageUrl) return null;
  return {
    src: coverImageUrl,
    absoluta: coverImageUrl.startsWith('/') ? `${SITE_URL}${coverImageUrl}` : coverImageUrl,
    width: 1200,
    height: 675,
  };
}
